export type ApiResponseHouseDetail = {
  id: number
  state: string
  lat: number
  lng: number
  type: string
  address: string
  number: number
  numberOrBlock: string
  neighborhood: string
  city: string
  additionalInfo: string
  complement: string
  floor: number
  shortId: number,
  forRent: boolean,
  forSale: boolean,
  areaTotal: number,
  numeroVagas: number,
}

export class HouseDetail {
  id: number
  state: string
  lat: number
  lng: number
  type: string
  address: string
  number: number
  numberOrBlock: string
  neighborhood: string
  city: string
  additionalInfo: string
  complement: string
  floor: number
  shortId: number
  forRent: boolean
  forSale: boolean
  areaTotal: number
  numeroVagas: number

  constructor(apiHouseDetail: ApiResponseHouseDetail) {
    this.id = apiHouseDetail.id;
    this.state = apiHouseDetail.state;
    this.lat = apiHouseDetail.lat;
    this.lng = apiHouseDetail.lng;
    this.type = apiHouseDetail.type;
    this.address = apiHouseDetail.address;
    this.number = apiHouseDetail.number;
    this.numberOrBlock = apiHouseDetail.numberOrBlock;
    this.neighborhood = apiHouseDetail.neighborhood;
    this.city = apiHouseDetail.city;
    this.additionalInfo = apiHouseDetail.additionalInfo;
    this.complement = apiHouseDetail.complement;
    this.floor = apiHouseDetail.floor;
    this.shortId = apiHouseDetail.shortId;
    this.forRent = apiHouseDetail.forRent;
    this.forSale = apiHouseDetail.forSale;
    this.areaTotal = apiHouseDetail.areaTotal;
    this.numeroVagas = apiHouseDetail.numeroVagas;
  }
}
